import { defineMessages } from 'react-intl';

import type { CustomField } from '@atlaskit/editor-common/extensions/field-definitions';

import type { FieldTransformer } from './fieldTypes.ts';

const i18n = defineMessages({
	contentIncludeFieldLabel: {
		id: 'fabric-extension-lib.field-mappings.include.field.contentInclude.label',
		description:
			'New label for the "Page to Include" field in the Include Content macro configuration panel, accounts for all content types instead of just pages',
		defaultMessage: 'Content to include',
	},
});

export const include: FieldTransformer<any> = {
	transformFields: async ({ fields, intl }) => {
		return fields.map((field) => {
			if (field.name !== 'defaultParameterValue') {
				return field;
			}

			return {
				...field,
				type: 'custom',
				label: intl.formatMessage(i18n.contentIncludeFieldLabel),
				// description talks about entering page using SPACEKEY:Page_title syntax
				// which no longer applies as users are now just picking from a dropdown
				description: undefined,
			} as CustomField;
		});
	},
};
